import Keycloak from 'keycloak-js';

const authBase = (
  process.env.REACT_APP_KEYCLOAK_URL || 'http://localhost:4702/auth'
).replace(/\/$/, '');

export const keycloak = new Keycloak({
  oidcProvider: authBase,
  clientId: process.env.REACT_APP_KEYCLOAK_CLIENT_ID || 'niadit',
});

let keycloakInitComplete = false;

export function isKeycloakInitialized(): boolean {
  return keycloakInitComplete;
}

export function markKeycloakInitialized(): void {
  keycloakInitComplete = true;
}

export function hasActiveKeycloakSession(): boolean {
  return Boolean(keycloak.authenticated && keycloak.token);
}
